import React from "react"
import { FlatButton } from "material-ui"
import { IUserDocument, ITimeoffRequestDocument, ETimeoffStatus, ELoggedInUserType, IAppliedInfo } from "../../../../models"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui"
import { browserHistory } from "react-router"
import strings from "../../../../localization/strings"
import moment from "moment"
import * as api from "../../../../api"
import autobind from "class-autobind"
import * as userActions from "../../../../actions/UserActions"
import UserStore from "../../../../stores/UserStore"
import AuthenticationStore from "../../../../stores/AuthenticationStore"
import * as permissonHelper from "../../../../helpers/permissionHelper"
import AppStateStore from "../../../../stores/AppStateStore"
interface IProps {
  user: IUserDocument
  loggedInUserType: ELoggedInUserType
  startDateUTC: Date | string
  endDateUTC: Date | string
  supervisorReadonlyForSelf: boolean
  height: number
}
interface IState {
  leaveRequests: ITimeoffRequestDocument[]
}

export default class LeaveRequestDashboard extends React.Component<IProps, IState> {
  private tableHeaderHeight = 30
  private tableBodyRowHeight = 25
  constructor(props) {
    super(props)
    this.state = {
      leaveRequests: []
    }
    autobind(this)
  }

  componentDidMount() {
    this.getPendingLeaveRequests()
    UserStore.on("change_reload_self_service_leave_dashboard", this.changeReloadLeaveRequests)
  }

  componentWillUnmount() {
    UserStore.removeListener("change_reload_self_service_leave_dashboard", this.changeReloadLeaveRequests)
  }

  changeReloadLeaveRequests() {
    UserStore.getReloadSelfServiceLeaveDashboard() &&
      this.setState({ leaveRequests: [] }, () => this.getPendingLeaveRequests())
  }

  getPendingLeaveRequests() {
    api.getEmployeeLeaveRequests(this.props.user.Id, this.props.startDateUTC, this.props.endDateUTC, null, null, "", [ETimeoffStatus.Requested, ETimeoffStatus.Approved])
      .then((res) => this.setState({ leaveRequests: res.data.Documents }))
  }

  handleAddNewLeaveRequest() {
    browserHistory.push(this.props.loggedInUserType === ELoggedInUserType.Employee ? `/es/leave_tracking` : `/user-details/${this.props.user.Id}/leave_tracking`)
    userActions.setRequireAddNewLeaveTracking()
  }

  render() {
    const showSubmitButton = (this.props.loggedInUserType === ELoggedInUserType.Employee || permissonHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.AddUserLeaveTracking)) && !this.props.supervisorReadonlyForSelf
    const tableBodyHeight = this.props.height - 15 - this.tableHeaderHeight - (showSubmitButton ? 40 : 0)
    const hasVScrollBar = tableBodyHeight - this.state.leaveRequests.length * this.tableBodyRowHeight < 0
    return (
      <div>
        <Table
          height={`${tableBodyHeight}px`}
          selectable={false}
          fixedHeader
          multiSelectable={false}
          onCellClick={() => browserHistory.push(this.props.loggedInUserType === ELoggedInUserType.Employee ? `/es/leave_tracking` : `/user-details/${this.props.user.Id}/leave_tracking`)}
        >
          <TableHeader
            displaySelectAll={false}
            adjustForCheckbox={false}
            enableSelectAll={false}
          >
            <TableRow style={{ height: this.tableHeaderHeight }}>
              <TableHeaderColumn style={{ padding: "0px 0px 0px 10px", height: this.tableHeaderHeight, cursor: "pointer" }}>{strings.Leave_Requests}</TableHeaderColumn>
              <TableHeaderColumn style={{ padding: 0, height: this.tableHeaderHeight, textAlign: "right", cursor: "pointer", width: 170 }}>{strings.Dates}</TableHeaderColumn>
              <TableHeaderColumn style={{ padding: 0, height: this.tableHeaderHeight, textAlign: "right", cursor: "pointer", width: 50 }}>{strings.Hours}</TableHeaderColumn>
              <TableHeaderColumn style={{ paddingRight: hasVScrollBar ? 27 : 10, paddingLeft: 0, paddingBottom: 0, paddingTop: 0, height: this.tableHeaderHeight, textAlign: "right", cursor: "pointer", width: 75 }}>{strings.Status}</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            displayRowCheckbox={false}
            deselectOnClickaway={false}
            showRowHover={false}
            stripedRows={false}
          >
            {this.state.leaveRequests.map((row, index) =>
              <TableRow key={index} style={{ height: this.tableBodyRowHeight, borderBottom: "none" }} >
                <TableRowColumn style={{ padding: "0px 0px 0px 10px", height: this.tableBodyRowHeight, cursor: "pointer" }} title={row.AccrualName}>{row.AccrualName}</TableRowColumn>
                <TableRowColumn style={{ padding: 0, height: this.tableBodyRowHeight, cursor: "pointer", textAlign: "right", width: 170 }}>
                  {moment(row.StartDate).local().subtract(moment(row.StartDate).utcOffset(), "minutes").isSame(moment(row.EndDate).local().subtract(moment(row.EndDate).utcOffset(), "minutes"), "day") ?
                    moment(row.StartDate).local().subtract(moment(row.StartDate).utcOffset(), "minutes").format("MM/DD/YYYY") :
                    `${moment(row.StartDate).local().subtract(moment(row.StartDate).utcOffset(), "minutes").format("MM/DD/YYYY")} - 
											${moment(row.EndDate).local().subtract(moment(row.EndDate).utcOffset(), "minutes").format("MM/DD/YYYY")}`
                  }
                </TableRowColumn>
                <TableRowColumn style={{ padding: 0, height: this.tableBodyRowHeight, cursor: "pointer", textAlign: "right", width: 50 }}>
                  {row.TotalHours}
                </TableRowColumn>
                <TableRowColumn style={{ padding: "0px 10px 0px 0px", height: this.tableBodyRowHeight, cursor: "pointer", textAlign: "right", width: 75 }}>
                  {(row.Status === ETimeoffStatus.Requested && strings.Requested) || (row.Status === ETimeoffStatus.Approved && strings.Approved)}
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {showSubmitButton &&
          <div style={{ marginTop: 15, textAlign: "center" }} id="LeaveRequestSubmitButton">
            <FlatButton
              data-intercom-target={"menu-Employees-Leave-Request-Dashboard-Btn-SubmitLeave"}
              label={strings.Submit_Leave.toUpperCase()}
              backgroundColor={AppStateStore.getFrontEndSettings().UISettings.AccentColor }
              hoverColor={AppStateStore.getFrontEndSettings().UISettings.AccentColor }
              labelStyle={{ color: "white" }}
              onClick={this.handleAddNewLeaveRequest}
            />
          </div>
        }
      </div>
    )
  }
}